import _ from "lodash";
import draftToHtml from "draftjs-to-html";
import { fetchApi } from "../../utils";

const mapField = data => {
  return {
    ...data,
    video: _.get(data, "desktop_video"),
    imageBanner: _.get(data, "media_desktop_image_data.full_file_path"),
    imageBannerMobile: _.get(data, "media_mobile_image_data.full_file_path"),
    reservation: _.reduce(
      _.get(data, "reservation"),
      (result, value, language) => {
        return {
          ...result,
          [language]: draftToHtml(value)
        };
      },
      {}
    )
  };
};

const fetchContactPageApi = () => {
  return fetchApi("page/contact")
    .then(res => _.get(res, "data"))
    .then(mapField);
};

export { fetchContactPageApi };



// WEBPACK FOOTER //
// ./src/services/page/contact.js